import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { AuthService } from './services/login.service';
import { routes } from './app.routes'; 

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    // FeaturePortal inietta HttpClient, che senza questo provider non e'
    // iniettabile. Finora non se n'era accorto nessuno perche' postQuery si
    // fermava prima, aspettando un token.
    provideHttpClient(),
    AuthService
  ]
};
